import ResetPassContainer from './ResetPassContainer';

export default ResetPassContainer;
